import React from "react";
import Col from "react-bootstrap/lib/Col";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { compose } from "redux";

import { actions as loansActions, selectors as loansSelectors } from "reducers/loans";

import TextField from "pages/_components/fields/TextField";
import AmountField from "pages/_components/fields/formik/AmountField";
import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import { shape, bool, func, string, instanceOf } from "prop-types";

import * as i18n from "util/i18n";
import { isDesktop } from "react-device-detect";

const FORM_ID = "loans.filters";

const LoansFilter = (props) => {
    const { setFieldValue, dispatch } = props;

    const hadleClear = () => {
        setFieldValue("loanNumber", "");
        setFieldValue("creditedAmount", null);

        dispatch(loansActions.clearFilters());
    };

    return (
        <Form>
            <Container className="container--layout align-items-center" gridClassName="form-content">
                <Col sm={12} md={6} className="col col-12 col-no-pad-mobile">
                    <div className="form-group form-group--select">
                        <Field
                            component={TextField}
                            idForm={FORM_ID}
                            name="loanNumber"
                            type="number"
                            onlyNumbers
                            hidePlaceholder
                        />
                    </div>
                </Col>

                <Col sm={12} md={6} className="col col-12 col-no-pad-mobile">
                    <Field
                        component={AmountField}
                        hideCurrency
                        idForm={FORM_ID}
                        name="creditedAmount"
                        placeholder={i18n.get(`currency.label.ARS`)}
                        prefix={i18n.get(`currency.label.ARS`)}
                        disableSelect
                    />
                </Col>

                <Col sm={12} md={6} className="col col-12 col-no-pad-mobile">
                    <Button bsStyle="outline" label="loans.filters.clear" onClick={hadleClear} />
                </Col>
                <Col sm={12} md={6} className={`col col-12 col-no-pad-mobile ${!isDesktop && "mt-8"}`}>
                    <Button bsStyle="primary" label="product.filters.filter" type="submit" />
                </Col>
            </Container>
        </Form>
    );
};

LoansFilter.propTypes = {
    activeLoans: instanceOf(Array),
    historicalLoans: instanceOf(Array),
    filters: shape({}),
    isDesktop: bool,
    dispatch: func.isRequired,
    closeSidebar: func.isRequired,
    setFieldValue: func,
    loanType: string.isRequired,
};

LoansFilter.defaultProps = {
    activeLoans: [],
    historicalLoans: [],
    filters: shape({}),
    isDesktop: bool,
    setFieldValue: () => {},
    loanType: string,
};

const mapStateToProps = (state) => ({
    activeLoans: loansSelectors.getActiveLoans(state),
    historicalLoans: loansSelectors.getHistoricalLoans(state),
    filters: loansSelectors.getFilters(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: (state) => ({
            loanNumber: state?.filters?.loanNumber || null,
            creditedAmount: state?.filters?.creditedAmount || null,
        }),
        validationSchema: () =>
            Yup.lazy(() =>
                Yup.object().shape({
                    loanNumber: Yup.number().nullable(),
                    creditedAmount: Yup.object()
                        .shape({
                            amount: Yup.number()
                                .nullable()
                                .typeError("Monto incorrecto"),
                        })
                        .nullable(),
                }),
            ),
        handleSubmit: ({ loanNumber, creditedAmount }, formikBag) => {
            const { dispatch, closeSidebar, activeLoans, historicalLoans, loanType } = formikBag.props;
            let filteredLoans = [];
            const loansToFilter = loanType === "A" ? activeLoans : historicalLoans;

            if (loanNumber !== null) {
                filteredLoans = loansToFilter.filter((loan) => loan.nroPrestamo === Number(loanNumber));
            }
            if (creditedAmount !== null) {
                filteredLoans =
                    filteredLoans.length > 0
                        ? filteredLoans.filter((loan) => loan.monto === Number(creditedAmount.amount))
                        : loansToFilter.filter((loan) => loan.monto === Number(creditedAmount.amount));
            }
            if (loanNumber === null && creditedAmount === null) {
                closeSidebar(false);
                return;
            }

            dispatch(loansActions.setFilters({ loanNumber, creditedAmount }, filteredLoans));

            closeSidebar(false);
        },
    }),
)(LoansFilter);
